import { StorageOption } from 'owa-storage-option';
import { OptionSubCategory } from 'owa-options-core';
import { getAccountInformation } from 'owa-storage-option';

let storageSubcategory: OptionSubCategory = {
    key: 'storage',
    titleStringKey: 'optionSubcategory_mailboxCleanup',
    options: [StorageOption],
    onSelected: () => {
        return getAccountInformation();
    },
};

export default storageSubcategory;
